import React, { useEffect, useState } from "react";
import "./avatar.scss";

export interface IProps {
    color?: AvatarColor;
    size?: "s" | "m" | "l";
}

export enum AvatarColor {
    green = 1,
    yellow = 2,
    purple = 3
};

export const Avatar:React.FC<IProps>  = (props) => {
    const [color, setColor] = useState<AvatarColor>(AvatarColor.green);

    useEffect(() => {
        setColor(props.color ? props.color: getRandomColor());
    }, []);

    const getRandomColor = (): AvatarColor => {
        const allColors = Object.keys(AvatarColor).filter(key => isNaN(Number(key)));
        const randomIndex = Math.floor(Math.random() * allColors.length);
        return allColors[randomIndex] as unknown as AvatarColor;
    }

    return (
        <div className={`avatar ${color} ${props.size ? props.size : "" }`}/>
    );
}